import SocialMediaIcon from 'components/SocialMediaIcon/SocialMediaIcon'
import React from 'react'
import KeywordStyle from './Style'
import { IKeyword } from './Types'
export default function Keyword({
  platform,
  text,
  sideIcon,
}: IKeyword): JSX.Element {
  return (
    <KeywordStyle.Keyword>
      {platform && <SocialMediaIcon platformName={platform} width={22} />}
      {text}
      {sideIcon && sideIcon}
    </KeywordStyle.Keyword>
  )
}
